import { gql } from "@apollo/client";

//Get Personas
export const OBTENER_COBROS = gql`
  query OBTENER_COBROS($UserId: ID, $fecha: String) {
    obtenerCobros(UserId: $UserId, fecha: $fecha) {
      id
      PlazaId
      turno
      fechaTrabajo
      fechaReporte
      PersonasModel {
        id
        nombre
        apellidos
      }
      PlazaModel {
        id
        nombre
      }
      UserModel {
        name
      }
      MovimientosModel {
        monto
        comision
        neto
        createdAt
      }
    }
  }
`;

export const CREAR_COBRO = gql`
  mutation CREATE_COBRO($input: InputCobro, $cobro: [InputMovimiento]) {
    agregarCobro(input: $input, cobro: $cobro)
  }
`;

export const ELIMINAR_COBRO = gql`
  mutation ELIMINAR_COBRO($id: ID) {
    eliminarCobro(id: $id)
  }
`;

export const OBTENER_COBROS_MES = gql`
  query OBTENER_COBROS($UserId: ID, $fecha: string) {
    obtenerCobrosMes(UserId: $UserId, fecha: $fecha) {
      id
      PlazaId
      turno
      fechaTrabajo
      fechaReporte
      PersonasModel {
        id
        nombre
        apellidos
      }
      PlazaModel {
        id
        nombre
      }
      UserModel {
        name
      }
      MovimientosModel {
        monto
        comision
        neto
        createdAt
      }
    }
  }
`;

export const LISTAR_TAZAS = gql`
  query LISTAR_TASA {
    listarTazas {
      id
      tasa
    }
  }
`;
